import React from 'react';
import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import HoursAndMenu from './components/HoursAndMenu';
import Gallery from './components/Gallery';
import ContactReservation from './components/ContactReservation';
import Footer from './components/Footer';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Open+Sans:wght@400;500;600;700&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    
    @media (max-width: 768px) {
      font-size: 15px;
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }
  
  body {
    font-family: ${theme.fonts.body};
    font-size: 1rem;
    line-height: 1.6;
    color: ${theme.colors.dark};
    background-color: ${theme.colors.light};
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    font-weight: 700;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }
  
  h1 {
    font-weight: 800;
  }
  
  a {
    text-decoration: none;
    color: ${theme.colors.primary};
    transition: all 0.3s ease;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  button, input, textarea, select {
    font-family: inherit;
  }
`;

const MainContent = styled.main`
  width: 100%;
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <MainContent>
        <Hero />
        <HoursAndMenu />
        <Gallery />
        <ContactReservation />
      </MainContent>
      <Footer />
    </>
  );
}

export default App;
